export const data = {
    name: "Completions",
    layout: [],
};
export default data;